import { EventPredictions } from '@go-shared/types/eventPrediction';
import { apiPost } from '.';

export async function predictEvents(venue: {
  property: string;
  venueRequestId: string;
  days: number;
}): Promise<EventPredictions[]> {
  const { property, venueRequestId, days } = venue;
  return apiPost(`/property/${property}/prediction/${venueRequestId}`, { days });
}